import type { JSX } from 'solid-js'
import { mergeProps, splitProps } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { SkeletonPropsType } from '~/types/Skeleton'

const variantClasses: Record<string, string> = {
  image: 'w-full h-40 rounded-lg',
  line: 'h-4 w-full rounded',
  input: 'h-12 w-full rounded-md',
  button: 'h-10 w-32 rounded-md',
  avatar: 'w-12 h-12 rounded-full',
  card: 'w-full h-32 rounded-lg',
  table: 'w-full h-20 rounded-md'
}

export default function Skeleton(props: SkeletonPropsType): JSX.Element {
  const merged = mergeProps(
    {
      variant: 'line',
      animated: true,
      shimmer: true,
      circle: false
    },
    props
  )

  const [local, others] = splitProps(merged, ['variant', 'width', 'height', 'circle', 'class', 'classList', 'animated', 'shimmer'])

  const getStyle = () => {
    const style: Record<string, string> = {}

    if (local.width !== undefined) {
      style.width = typeof local.width === 'number' ? `${local.width}px` : local.width
    }

    if (local.height !== undefined) {
      style.height = typeof local.height === 'number' ? `${local.height}px` : local.height
    }

    return style
  }

  return (
    <div
      class={twMerge('rounded-md bg-border relative overflow-hidden', local.animated ? 'animate-pulse' : '', local.circle ? 'rounded-full' : '', variantClasses[local.variant], local.class || '')}
      classList={local.classList}
      style={getStyle()}
      {...others}
    >
      {local.shimmer && (
        <div class="absolute inset-0 skeleton-shimmer">
          <div class="h-full w-1/2 bg-linear-to-r from-transparent via-surface-muted/60 to-transparent" />
        </div>
      )}
    </div>
  )
}
